import PropTypes from 'prop-types';
import { FaFilter } from 'react-icons/fa';

/**
 * Filter button component.
 * 
 * @param {object} props
 * @param {string} props.id - button ID
 * @param {Function} props.action - function to run when the button is clicked
 */
const FilterButton = ({ id, type, action }) => {
    return (
        <button id={id} className={type} onClick={action}>
            {<FaFilter />}
        </button>
    );
};

FilterButton.propTypes = {
    id: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
};


export default FilterButton;
